import React from "react"
import moment from "moment"
import Link from "next/link"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import img from "@/assets/img/gallery/gallery-1.jpg"
import 'moment/locale/fr'
import { categories } from "@/services/school"
moment.locale('fr')

type CardProps = {
    schoolThematic: SchoolThematic
}

export default function Card({
    schoolThematic
}: CardProps) {

    return (
        <Link href={createObjectPagePathname('SchoolThematic', schoolThematic)}>
            <div className="bubble ssthematiquescolaire mx-auto">
                <div>
                    <div className="theme align-self-end mx-auto">{schoolThematic.name.slice(0, 30) + ((schoolThematic.name.length > 30) ? '...' : '')}</div>
                    <div className="align-self-start mx-auto">
                        {schoolThematic.categories.filter(category => category in categories).map((category, indexCategory) => {
                            return (
                                <React.Fragment key={'category-' + indexCategory}>
                                    <div className="badge-thematique" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={"Thématique : " + categories[category].name}><i className={categories[category].icon} /></div>            
                                </React.Fragment>                                
                            )
                        })}                        
                    </div>
                </div>
            </div>
            <span className="info">
                {schoolThematic.accomodation.name}
            </span>
        </Link>
    )
}